import ChangePasswordModal from "./ChangePassword";
import DeauthorizeSessionsModal from "./DeauthorizeSessions";
import NewPasskeyModal from "./NewPasskey";
import NewSecurityKeyModal from "./NewSecurityKey";
import QrCodeModal from "./QrCode";
import ConfirmEncryptionUpdateModal from "./ConfirmEncryptionUpdate";

const securityModalsComponents = {
  ChangePasswordModal,
  DeauthorizeSessionsModal,
  NewPasskeyModal,
  NewSecurityKeyModal,
  QrCodeModal,
  ConfirmEncryptionUpdateModal
}

export default securityModalsComponents;